import type { TenantRecord } from 'src/types/tenant';
import { getContext, setContext } from 'svelte';

export class TenantContext {
	tenant: TenantRecord = $state();

	constructor() {}
}

export const TENANT_CONTEXT_KEY = Symbol('tenant');

export function getTenantContext() {
	return getContext<TenantContext>(TENANT_CONTEXT_KEY);
}

export function setTenantContext(ctx: TenantContext) {
	setContext(TENANT_CONTEXT_KEY, ctx);
}
